import * as React from "react";
import ServiceLogs from "./ServiceLogs";

import {withRouter} from "react-router";
class ServiceLogsParams extends React.Component{

    render() {
        return (
            <ServiceLogs
                {...this.props}
                qs = {this.props.location.pathname}
            />
        );
    }
}

export default withRouter(ServiceLogsParams);